import React, { ComponentProps, FunctionComponent } from "react";

const ConnectionIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 10 11",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,

    /*#__PURE__*/ React.createElement("rect", {
      y: "4",
      width: "2",
      height: "7",
      rx: "1",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("rect", {
      x: "4",
      y: "6",
      width: "2",
      height: "5",
      rx: "1",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("rect", {
      x: "8",
      width: "2",
      height: "11",
      rx: "1",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(ConnectionIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
